import React from "react";
import DistributorsHeroSection from "../../../subscreens/customer/distributorsHeroSection/DistributorsHeroSection";
import FeaturedDistributorsSection from "../../../subscreens/customer/featuredDistributorsSection/FeaturedDistributorsSection";
import AllDistributorsSection from "../../../subscreens/customer/allDistributorsSection/AllDistributorsSection";
import BecomeDistributorSection from "../../../subscreens/customer/becomeDistributorSection/BecomeDistributorSection";
import MyLayout from "../../../layouts/customer/MyLayout";

const Distributors = () => {
    return (
        <MyLayout>
        <DistributorsHeroSection/>
        <FeaturedDistributorsSection/>
        <AllDistributorsSection/>
        <BecomeDistributorSection/>
        </MyLayout>
    );
};

export default Distributors;